import { Plan } from './plan';
import type { PlanDTO } from './types';

export class PlanRepository {
  plans: Plan[];

  constructor(rawPlans: PlanDTO[]) {
    this.plans = rawPlans.map(
      (x) => new Plan(x.identifier, x.feature_group, x.sample_rate, x.cc_daily_allowance),
    );
  }

  byId(id: string | undefined): Plan {
    const plan = this.plans.find((x) => x.identifier === id);

    if (!this.plans.length || !id) {
      // this.plans having a length of 0 means we're still waiting on the settings endpoint to load.
      // If id is undefined it means we're still waiting on the currentSite to load
      return {
        identifier: 'basic_2000_cc',
        featureGroup: 'basic',
        sampleRate: 2000,
        ccDailyAllowance: 35,
      };
    }

    if (!plan) {
      throw new Error(`Plan not found for id: ${id}`);
    }

    return plan;
  }
}
